// Auto-generated by scripts/split_ui.js from data/manasikRef.js — do not edit.
export const REF_UI = {
  "pageTitle": {
    "id": "Perpustakaan Manasik",
    "en": "Manasik Library",
    "ar": "مكتبة المناسك",
    "fr": "Bibliothèque des Manasik",
    "de": "Manasik-Bibliothek",
    "es": "Biblioteca de Manasik",
    "ru": "Библиотека Манасик",
    "zh": "朝觐礼仪（Manasik）图书馆",
    "ja": "マナシク（Manasik）ライブラリ",
    "ko": "마나식(Manasik) 도서관",
    "hi": "मानासिक (Manasik) पुस्तकालय"
  },
  "pageSub": {
    "id": "Pembahasan mendalam seputar hukum dan tata cara umrah & haji, lengkap dengan dalilnya.",
    "en": "An in-depth discussion of the rulings and procedures of Umrah & Hajj, complete with their evidences.",
    "ar": "نقاش معمّق حول أحكام العمرة والحج وإجراءاتهما، مع أدلتها الشرعية الكاملة.",
    "fr": "Une discussion approfondie sur les règles et les procédures de la Umrah et du Hajj, accompagnée de leurs preuves.",
    "de": "Eine eingehende Erörterung der Regeln und Verfahren der Umrah & Hajj, vollständig mit ihren Belegen.",
    "es": "Una discusión en profundidad sobre las normas y procedimientos de la Umrah y el Hajj, con sus evidencias completas.",
    "ru": "Углублённое обсуждение правил и порядка совершения Умры и Хаджа с полным приведением доказательств.",
    "zh": "深入探讨副朝（Umrah）与正朝（Hajj）的法律规定及程序，并附有完整的证据依据。",
    "ja": "ウムラとハッジの法規と手順に関する詳細な考察で、その根拠とともに完全に記載されています。",
    "ko": "우므라(Umrah)와 하지(Hajj)의 규정 및 절차에 관한 심층적인 논의로, 완전한 증거와 함께 제공됩니다.",
    "hi": "उमरह और हज के नियमों और प्रक्रियाओं पर एक गहन चर्चा, जो उनके पूर्ण साक्ष्यों के साथ प्रस्तुत की गई है।"
  },
  "dashLabel": {
    "id": "Referensi Manasik",
    "en": "Manasik Reference",
    "ar": "مرجع المناسك",
    "fr": "Référence des Manasik",
    "de": "Manasik-Referenz",
    "es": "Referencia de Manasik",
    "ru": "Справочник Манасик",
    "zh": "朝觉礼仪（Manasik）参考资料",
    "ja": "マナーシク（Manasik）リファレンス",
    "ko": "마나식(Manasik) 참고 자료",
    "hi": "मनासिक (Manasik) संदर्भ"
  },
  "dashHint": {
    "id": "Kajian mendalam: jenis haji, miqat, dam, badal & lainnya",
    "en": "In-depth study: types of Hajj, Miqat, Dam, Badal & more",
    "ar": "دراسة معمّقة: أنواع الحج، المواقيت، الدم، البدل وغيرها",
    "fr": "Étude approfondie : types de Hajj, Miqat, Dam, Badal et plus encore",
    "de": "Eingehende Studie: Arten des Hajj, Miqat, Dam, Badal und mehr",
    "es": "Estudio en profundidad: tipos de Hajj, Miqat, Dam, Badal y más",
    "ru": "Углублённое изучение: виды Хаджа, Микат, Дам, Бадал и другое",
    "zh": "深入研究：朝觉（Hajj）的种类、米卡特（Miqat）、达姆（Dam）、巴达勒（Badal）等",
    "ja": "深掘り学習：ハッジの種類、ミーカート（Miqat）、ダム（Dam）、バダル（Badal）など",
    "ko": "심층 연구: 하지(Hajj)의 종류, 미까트(Miqat), 담(Dam), 바달(Badal) 등",
    "hi": "गहन अध्ययन: हज के प्रकार, मीक़ात (Miqat), दम (Dam), बदल (Badal) और अन्य"
  },
  "evidenceLabel": {
    "id": "Dalil",
    "en": "Evidence",
    "ar": "الدليل",
    "fr": "Preuve",
    "de": "Beleg",
    "es": "Evidencia",
    "ru": "Довод",
    "zh": "证据",
    "ja": "根拠（dalil）",
    "ko": "증거 (달릴, Dalil)",
    "hi": "दलील (Dalil)"
  },
  "back": {
    "id": "Kembali ke daftar",
    "en": "Back to list",
    "ar": "العودة إلى القائمة",
    "fr": "Retour à la liste",
    "de": "Zurück zur Liste",
    "es": "Volver a la lista",
    "ru": "Вернуться к списку",
    "zh": "返回列表",
    "ja": "リストに戻る",
    "ko": "목록으로 돌아가기",
    "hi": "सूची पर वापस जाएं"
  },
  "readTopic": {
    "id": "Baca selengkapnya",
    "en": "Read more",
    "ar": "اقرأ المزيد",
    "fr": "Lire la suite",
    "de": "Mehr lesen",
    "es": "Leer más",
    "ru": "Читать далее",
    "zh": "阅读全文",
    "ja": "続きを読む",
    "ko": "더 읽기",
    "hi": "और पढ़ें"
  },
  "narrateBtn": {
    "id": "Dengarkan Artikel",
    "en": "Listen to Article",
    "ar": "استمع إلى المقال",
    "fr": "Écouter l'article",
    "de": "Artikel anhören",
    "es": "Escuchar el artículo",
    "ru": "Прослушать статью",
    "zh": "收听文章",
    "ja": "記事を聴く",
    "ko": "기사 듣기",
    "hi": "लेख सुनें"
  },
  "handbookBtn": {
    "id": "Unduh Buku Panduan (PDF)",
    "en": "Download Handbook (PDF)",
    "ar": "تنزيل الدليل (PDF)",
    "fr": "Télécharger le manuel (PDF)",
    "de": "Handbuch herunterladen (PDF)",
    "es": "Descargar el manual (PDF)",
    "ru": "Скачать руководство (PDF)",
    "zh": "下载手册（PDF）",
    "ja": "ハンドブックをダウンロード（PDF）",
    "ko": "핸드북 다운로드 (PDF)",
    "hi": "हैंडबुक डाउनलोड करें (PDF)"
  },
  "disclaimer": {
    "id": "Materi ini mengikuti pendapat mayoritas ulama Ahlus Sunnah dan mencatat perbedaan besar antar mazhab bila relevan. Tetaplah mengikuti bimbingan pembimbing/ustadz rombongan Anda untuk kasus khusus.",
    "en": "This material follows the opinion of the majority of Ahlus Sunnah scholars and notes significant differences among the madhabs where relevant. Always follow the guidance of your group's supervisor/ustadz for specific cases.",
    "ar": "تتبع هذه المادة رأي جمهور علماء أهل السنة، وتُشير إلى الخلافات الجوهرية بين المذاهب عند الاقتضاء. التزم دائمًا بتوجيهات مشرف رحلتك أو أستاذها في الحالات الخاصة.",
    "fr": "Ce contenu suit l'opinion de la majorité des savants d'Ahlus Sunnah et signale les différences significatives entre les madhabs lorsque cela est pertinent. Suivez toujours les conseils du superviseur/ustadz de votre groupe pour les cas particuliers.",
    "de": "Dieses Material folgt der Meinung der Mehrheit der Ahlus-Sunnah-Gelehrten und weist auf wesentliche Unterschiede zwischen den Madhabs hin, wo relevant. Befolgen Sie stets die Anleitung des Betreuers/Ustadz Ihrer Gruppe in besonderen Fällen.",
    "es": "Este material sigue la opinión de la mayoría de los eruditos de Ahlus Sunnah y señala las diferencias significativas entre los madhabs cuando es relevante. Siga siempre la orientación del supervisor/ustadz de su grupo para casos específicos.",
    "ru": "Данный материал следует мнению большинства учёных Ахлюс-Сунна и отмечает существенные разногласия между мазхабами там, где это уместно. Всегда следуйте руководству наставника/устаза вашей группы в особых случаях.",
    "zh": "本内容遵循大多数逊尼派学者的意见，并在相关情况下注明各法学派之间的重大分歧。对于特殊情况，请务必遵从您所在团队的领队/导师的指导。",
    "ja": "この資料はアフルス・スンナの多数派学者の見解に基づき、関連する場合には各マズハブ間の重要な相違点を示しています。個別のケースについては、必ずご自身のグループの引率者／ウスタズの指導に従ってください。",
    "ko": "이 자료는 아흘루스 순나 다수 학자들의 견해를 따르며, 관련이 있는 경우 각 마드합 간의 주요 차이점을 명시합니다. 특별한 경우에는 반드시 소속 그룹의 지도자/우스타즈의 안내를 따르십시오.",
    "hi": "यह सामग्री अहलुस सुन्नह के बहुसंख्यक उलमा की राय का अनुसरण करती है और जहाँ प्रासंगिक हो, मज़ाहिब के बीच प्रमुख मतभेदों को दर्शाती है। विशेष मामलों में सदैव अपने दल के पर्यवेक्षक/उस्ताज़ के मार्गदर्शन का पालन करें।"
  }
};
